(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template-var2"]) return;
  try {
    
	function jsUcfirst(string) {
       return string.charAt(0).toUpperCase() + string.slice(1);
    }
	var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    };
	$(document).ready(function() {
      console.log('sss==>', getUrlParameter('landing'));  
      if(getUrlParameter('landing'))  {
        var title =  'Replacement Filter for: ' + jsUcfirst(getUrlParameter('landing').replace('-', ' ') + ' by Refresh');
        $("#product-single__title-id").text(title);
      }                                       
                                             

    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
	function jsUcfirst(string) {
       return string.charAt(0).toUpperCase() + string.slice(1);
    }
	var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    };
	$(document).ready(function() {
      console.log('sss==>', getUrlParameter('landing'));  
      if(getUrlParameter('landing'))  {
        var title =  'Replacement Filter for: ' + jsUcfirst(getUrlParameter('landing').replace('-', ' ') + ' by Refresh');
        $("#product-single__title-id").text(title);
      }                                       
                                             

    });


  } catch(e) { console.error(e); }
})();
})();
